import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ReCaptchaV3Service } from "ng-recaptcha";
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { NgcCookieConsentService } from "ngx-cookieconsent";

declare let gtag: Function; // For GA4

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit{
  title = 'cim-tamega-sousa';
  private token: string = '';
  movieData: any;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private ccService: NgcCookieConsentService)
  {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(environment.defaultLanguage);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    let lang = localStorage.getItem('language');
    let exists = environment.systemLanguages.some(language => language.code === lang);

    if (lang != 'null' && lang != null && exists) {
      translate.use(lang);
    } else {
      translate.use(environment.defaultLanguage);
      localStorage.setItem('language', environment.defaultLanguage);
    }

    this.translate
      .get('cookies')
      .subscribe(trans => {
        // Override default messages with the translated ones
        if(this.ccService.getConfig() != undefined){
          this.ccService.getConfig().content = {
            message: trans['message'],
            allow: trans['allow'],
            deny: trans['deny'],
            link: trans['link'],
          }
        }
        this.ccService.destroy(); // remove previous cookie bar (with default messages)
        this.ccService.init(this.ccService.getConfig()); // update config with translated messages
      });
  }

  ngOnInit(){
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {
        this.token = token;
      });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const fullUrl = window.location.href; // Full URL
        const pagePath = window.location.pathname; // Path after domain
        
        gtag('event', 'page_view', {
          page_path: pagePath,
          page_title: document.title,
          full_url: fullUrl,
          'subdomain': 'website'
        });
        
      }
    })

  }
}
